import { type QueryClient } from '@tanstack/react-query'
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router'

export const Route = createRootRouteWithContext<{ queryClient: QueryClient; auth: unknown }>()({
  component: () => (
    <main>
      <Outlet />
    </main>
  ),
})
